var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "default-modal",
        {
          attrs: {
            name: "add-customer-modal",
            autofocus: _vm.$refs.addCustomerForm,
            successHandler: _vm.handleStoreCustomer,
            title: _vm.title,
            width: "sm"
          },
          on: { hide: _vm.handleHide },
          model: {
            value: _vm.modalOpened,
            callback: function($$v) {
              _vm.modalOpened = $$v
            },
            expression: "modalOpened"
          }
        },
        [
          _c(_vm.formComponent, {
            ref: "addCustomerForm",
            tag: "component",
            attrs: { slot: "content", action: _vm.action },
            slot: "content",
            model: {
              value: _vm.formData,
              callback: function($$v) {
                _vm.formData = $$v
              },
              expression: "formData"
            }
          })
        ],
        1
      ),
      _c(
        "q-page-sticky",
        { attrs: { position: "bottom-right", offset: [18, 18] } },
        [
          _c(
            "q-fab",
            { attrs: { color: "primary", icon: "add", direction: "up" } },
            [
              _c(
                "q-fab-action",
                {
                  staticClass: "add-company-btn",
                  attrs: { color: "dark", icon: "business" },
                  on: {
                    click: function($event) {
                      _vm.handleAddCustomer("company")
                    }
                  }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      attrs: {
                        anchor: "center right",
                        self: "center left",
                        offset: [10, 0]
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tc("company", 1)) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "q-fab-action",
                {
                  staticClass: "add-person-btn",
                  attrs: { color: "dark", icon: "person_add" },
                  on: {
                    click: function($event) {
                      _vm.handleAddCustomer("person")
                    }
                  }
                },
                [
                  _c(
                    "q-tooltip",
                    {
                      attrs: {
                        anchor: "center right",
                        self: "center left",
                        offset: [10, 0]
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$tc("person", 1)) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }